module.exports = __webpack_public_path__ + "img/csr10.5ae54a53.jpg";